import React ,{useEffect}from 'react';
import { useNavigate } from 'react-router-dom';  // Import useNavigate from react-router-dom
import './SuccessModal.css';  // You can style this modal as you like.
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle,faArrowRightFromBracket, faArrowRight} from '@fortawesome/free-solid-svg-icons';

const SuccessModal = ({navigate,planType}) => {

  useEffect(() => {
    window.history.replaceState(null, '', '/');
  }, []);


    const handleRedirect = () => {
      if(planType === 'Prepbot'){
        navigate('/landingPage/prepBot', { state: { activeButton: 'PrepGuru' } });
      }
      else if(planType==='Mockbot'){
        navigate('/landingPage/mockBot', { state: { activeButton: 'MockGuru' } });
      }
      else if (planType === 'Resume') {
          navigate('/landingPage/resumeExpert', { state: { activeButton: 'ResumeGuru' } });
      } else if (planType === 'Jd') {
          navigate('/landingPage/jdExpert', { state: { activeButton: 'JDGuru' } });
      } 
  };

  return (
    <div className="success-modal-overlay">
      <div className="success-modal-content">
        <div className="success-modal-header">
          <span> <FontAwesomeIcon icon={faCheckCircle} /></span>
        </div>
        <div className="success-modal-body">
          <h2>Payment Successful!</h2>
          <p>Your payment has been successfully processed.</p>
        </div>
        <div className="success-modal-footer">
          <button className='success-btn'onClick={handleRedirect}>Continue <FontAwesomeIcon icon={faArrowRight} /></button>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
